import { IUseContentPagePreviewProps } from 'components/Pages/Admin/shared/ItinerariesItemLanding/types';

import { getHandledPageName } from '../../../utils';
import * as types from './../../types';

type Props = types.ActivityFormValues | (IUseContentPagePreviewProps & types.ActivityFormValues);

export const handleFormValues = (formValues: Props) => {
  const handle = getHandledPageName(formValues);

  // areaConfirmed should be false because we create simple area
  const handledArea = {
    areaName: formValues.area?.name,
    areaId: formValues.area?.id,
    areaConfirmed: formValues.area?.confirmed,
  };

  const res = { ...formValues, ...handledArea, handle };

  return res;
};
